// Global Store

export const globalStore = (Alpine) => Alpine.store('global', {

    filters: {
        event_month: '',
        event_types: [],
    },

    // События отобранные на странице подбора событий
    suggested_events: [],

    // Подсказки при поиске из истории поисковых запросов
    search_suggestions_history: Alpine.$persist([])
        .as('search_suggestions_history'),

    // Использовать альтернативный primary color
    use_alt_primary_color: false,

    particle_cooldown_time: 30000, // 30 секунд

    particle_cooldown_last_time: Alpine.$persist(null),

    // Нормализация для СРАВНЕНИЯ записей истории (регистр + ё/е + пробелы).
    // Совпадает с normalizeSuggestionText в site-header.js: один и тот же запрос
    // приходит сюда в разных формах (сырой this.state.query из URL при init и
    // normalizeQuery(...) при поиске со схлопнутыми пробелами), и точечный ===
    // их не ловил — отсюда дубли в истории.
    normalizeSearchHistoryKey(suggestion) {
        return (suggestion || '')
            .toLowerCase()
            .replace(/ё/g, 'е')
            .replace(/\s+/g, ' ')
            .trim();
    },

    addSearchHistory(suggestion) {

        console.log('addSearchHistory', suggestion);

        // Чистим отображаемый текст (схлопываем пробелы), чтобы в истории не
        // оседали варианты одной строки, различающиеся только пробелами.
        suggestion = (suggestion || '').replace(/\s+/g, ' ').trim();

        if (!suggestion.length) {
            return;
        }

        // Удаляем подсказку если она уже есть (по нормализованному ключу)
        Alpine.store('global').deleteSearchHistory(suggestion);

        // Добавляем подсказку в начало массива
        Alpine.store('global').search_suggestions_history.unshift(suggestion);

        // Оставляем в массиве последние несколько записей
        Alpine.store('global').search_suggestions_history
            = Alpine.store('global').search_suggestions_history.slice(0, 16);

        console.debug(Alpine.store('global').search_suggestions_history);
    },

    deleteSearchHistory(suggestion) {

        console.debug('deleteSearchHistory');

        const key = Alpine.store('global').normalizeSearchHistoryKey(suggestion);

        // Удаляем ВСЕ совпадающие по нормализованному ключу записи — это также
        // вычищает дубли, накопившиеся в localStorage до этой логики.
        Alpine.store('global').search_suggestions_history
            = Alpine.store('global').search_suggestions_history.filter(
                item => Alpine.store('global').normalizeSearchHistoryKey(item) !== key
            );

        console.debug(Alpine.store('global').search_suggestions_history);
    },

    dispatchFormAttemptEvent(formName, data, response) {
        document.dispatchEvent(new CustomEvent('form-send-attempt', {
            detail: {
                formName: formName ?? '',
                data: data ?? null
            }
        }));
    },

    dispatchFormSuccessEvent(formName, data, response) {
        document.dispatchEvent(new CustomEvent('form-send-success', {
            detail: {
                formName: formName ?? '',
                data: data ?? null,
                response: response ?? null
            }
        }));
    },

    isParticleCooldownActive() {
        let currentTime = new Date().getTime();
        let lastTime = this.particle_cooldown_last_time ?? 0;
        let diff = currentTime - lastTime;
        console.log(diff);
        return diff < this.particle_cooldown_time;
    },

    setParticleCooldown() {
        this.particle_cooldown_last_time = new Date().getTime();
    }

});
